import { Box, Button, Text } from '@chakra-ui/react';
import styles from '@/pages/automation/jobs/cellRenderer/JobStatusCellRenderer.module.css';

const STATUS_CONFIG = {
    available: { type: 'active', label: 'Available' },
    verified: { type: 'active', label: 'Verified' },
    verify: { type: 'processing', label: 'Verify' },
    disabled: { type: 'disabled', label: 'Disabled' },
};

const SSOStatusCellRenderer = ({ status, onClick, isLoading, ...rest }) => {
    const key = status?.toLowerCase();
    const config = STATUS_CONFIG[key] ?? {
        type: 'disabled',
        label: status ?? 'Unknown',
    };
    const isClickable = key === 'verify' && Boolean(onClick);

    if (isClickable) {
        return (
            <Button
                size="sm"
                h="28px"
                minW="80px"
                px={4}
                bg="orange.400"
                color="white"
                fontWeight="semibold"
                borderRadius="md"
                isLoading={isLoading}
                loadingText="Verifying…"
                _hover={{ bg: 'orange.500' }}
                _active={{ bg: 'orange.600' }}
                onClick={onClick}
                {...rest}>
                {config.label}
            </Button>
        );
    }

    return (
        <Box
            className={`${styles.tag} ${styles[config.type + 'Tag']}`}
            onClick={isClickable ? onClick : undefined}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: isClickable ? 'pointer' : 'default',
                opacity: isLoading ? 0.6 : 1,
                width: 'fit-content',
                minWidth: '80px',
            }}
            {...rest}>
            <Text isTruncated>{isLoading ? 'Verifying…' : config.label}</Text>
        </Box>
    );
};

export default SSOStatusCellRenderer;
